





































































































import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import SettingVue from "../components/IntelligentVoucherList/Setting.vue";

@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "setting": SettingVue
    }
})
export default class IntelligentVoucher extends Vue {
    fns: Voucher.IntelligentVoucher[] = [
        {
            icon: "invoice",
            scale: 12,
            title: "增值税票",
            type: 0,
            link1: "/invoice",
            link2: "/verifyVATInvoicer",
            link3: "/intelligentVoucherList",
            // link4: "/invoicescan",
            // link4Text: "扫描",
            link1Text: "新增",
            link2Text: "审核",
            disabled: false,
        },
        {
            icon: "journal",
            scale: 12,
            title: "日记账",
            type: 1,
            link1: "/journal",
            link2: "/verifyJournal",
            link3: "/intelligentVoucherList",
            link1Text: "新增",
            link2Text: "审核",
        },
        {
            icon: "other",
            scale: 12,
            title: "其他票据",
            type: 2,
            link1: "/addOtherBill",
            link2: "/verifyOthers",
            link3: "/intelligentVoucherList",
            link1Text: "新增",
            link2Text: "审核",
            disabled: false,
        },
        {
            icon: "payroll",
            scale: 9,
            title: "工资表",
            type: 3,
            link1: "/payroll",
            link2: "/verifyPayroll",
            link3: "/intelligentVoucherList",
            link1Text: "新增",
            link2Text: "审核",
        },
    ];

    // 跳转
    toLink(link: string, type?: number, isDisabled?: boolean) {
        if (!isDisabled) {
            if (link === "/intelligentVoucherList") {
                let params: any = {
                    path: "/intelligentVoucherList",
                    query: { class: type },
                };
                this.$router.push(params);
            } else {
                if (link != "") this.$router.push({ path: link });
            }
        }
    }

    setVisible = false;
    currentType: number | null = null;
    async clickSet(type: number) {
        this.currentType = type;
        this.setVisible = true;
        // const res = await Vue.axios.get(
        //     `systemsettings/find?accountBookId=${this.$store.state.accountBook.id}&keyword=INVOICE_AUTO`
        // );
        // let action;
        // try {
        //     action = await this.$confirm(
        //         `亲，是否生成标准科目（若不生成将影响纳税申报表的取数）? \n当前状态为: ${
        //             res.data.value === "1" ? "开启" : "关闭"
        //         }`,
        //         "温馨提示",
        //         {
        //             confirmButtonText: "开启",
        //             cancelButtonText: "关闭",
        //             distinguishCancelAndClose: true,
        //         }
        //     );
        // } catch (e) {
        //     action = e;
        // }
        // if (action !== "close") {
        //     // console.log(action)
        //     Vue.axios.post(`systemsettings/save`, {
        //         accountBookId: this.$store.state.accountBook.id,
        //         keyword: "INVOICE_AUTO",
        //         value: action === "confirm" ? 1 : 0,
        //     });
        // }
    }

    async clickPayRoll() {
        const res = await Vue.axios.get(
            `systemsettings/find?accountBookId=${this.$store.state.accountBook.id}&keyword=PAY_SHEET_AUTO`
        );
        let action;
        try {
            action = await this.$confirm(
                `亲，是否生成标准凭证? \n当前状态为: ${
                res.data.value === "1" ? "是" : "否"
                }`,
                "温馨提示",
                {
                    confirmButtonText: "是",
                    cancelButtonText: "否",
                    distinguishCancelAndClose: true,
                }
            );
        } catch (e) {
            action = e;
        }
        if (action !== "close") {
            // console.log(action)
            Vue.axios.post(`systemsettings/save`, {
                accountBookId: this.$store.state.accountBook.id,
                keyword: "PAY_SHEET_AUTO",
                value: action === "confirm" ? 1 : 0,
            });
        }
    }

}
